import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=00e2c732&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=00e2c732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2c732",
  null
  
)

export default component.exports